const CheckForLoggedUser = () => {
    return (localStorage.getItem('v') !== null) ? true : false;
}

export default CheckForLoggedUser;